




























































































































































import { Component, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { mixins } from 'vue-class-component';
import BaseTable from '@/components/BaseTable.vue';
import BasePagination from '@/components/base/BasePagination.vue';
import BaseLoading from '@/components/base/BaseLoading.vue';
import { PaginationMixin } from '@/components/base/pagination.mixin';
import { RootState } from '@/store/store';
import SortableTableHeader from '@/components/SortableTableHeader.vue';
import CourseRow from './CourseRow.vue';
import { CourseListItem } from '@/store/modules/jtms/course/course.types';
import { SortOrder } from '@/jbi-shared/types/search.types';
import { CourseSortColumns } from '@/jbi-shared/types/jtms.types';

@Component({
  components: {
    BaseTable,
    BasePagination,
    BaseLoading,
    CourseRow,
    SortableTableHeader
  }
})
export default class CourseList extends mixins(PaginationMixin) {
  @Prop() public items!: CourseListItem[];
  @Prop(Number) public currentPage!: number;
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;
  @Prop(String) public courseLabel!: string;
  @Prop(String) public sortColumn!: string;
  @Prop(String) public sortOrder!: SortOrder;

  public courseRowKey: number = Math.floor(Math.random() * 999);

  @State((state: RootState) => state.course.apiState.getCourses.success)
  public getCoursesSuccess!: boolean;

  get courses() {
    return this.items || [];
  }

  get isPaginated() {
    return typeof this.totalNumberOfPage === 'number';
  }

  get CourseSortColumns() {
    return CourseSortColumns;
  }

  public onClickHeaderColumn(columnName: string) {
    if (this.sortColumn === columnName) {
      return this.$emit('sort', {
        sortColumn: columnName,
        sortOrder:
          this.sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC
      });
    }
    this.$emit('sort', {
      sortColumn: columnName,
      sortOrder: SortOrder.DESC
    });
    this.courseRowKey += 1;
  }

  public getSortOrderOfColumn(name: string) {
    if (this.sortColumn === name) {
      return this.sortOrder;
    }
    return SortOrder.ASC;
  }
}
